import HarvestParameter from './HarvestParameter';

export default HarvestParameter;
